import styled from '@emotion/styled'
import { Avatar, Button, Chip, Dialog, Divider, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, Tooltip } from '@mui/material';
import { Box } from '@mui/system'
import React, { useContext, useEffect, useState } from 'react'
import Check from '@mui/icons-material/Check';
import ExtendResearch from './ExtendResearch';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useAuth from '../../hooks/useAuth';
import ProfileContext from '../../context/ProfileContext';
const Wrapper=styled('span')(({theme})=>({
    padding: '36px 14px 37px 17px',
    background:theme.palette.background.default,
  boxShadow: `0px 0px 7px ${theme.palette.background.shadow}`,
     width: '100%',
    border: `1px solid ${theme.palette.third.main}`,
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    borderRadius: '3px',

}))
const Header=styled(Box)(({theme})=>({
    color: props=>props.active?theme.palette.primary.main:theme.palette.third.main,
    fontWeight: '600',
    fontSize: '16px',
}))
const StyledTypography=styled(Box)(({theme})=>({
    color:theme.palette.third.main,
    fontWeight: '600',
    fontSize: '16px',
}))
const Detail=styled(Box)(({theme})=>({
    display:'flex',
    justifyContent:'space-around'
}))
const MemberWrap=styled(Box)(({theme})=>({
    display:'flex',
    gap:'10px',
    flexWrap:'wrap'
}))
const steps = [
  'Submitted',
  'Pending',
  'Active',
  'Expired',
];
// const members=[
//   {
//     name:"Solomon Tesfa",
//     pic:'/images/photo.png',
//     email:'solomon@gmail.com',
//     role:'Co PI'
//   },
//    {
//     name:"Tsion Tesfa",
//     pic:'/images/photo.png',
//     email:'solomon@gmail.com',
//     role:'PI',
//   },
//    {
//     name:"Leul Tesfa",
//     pic:'/images/photo.png',
//     email:'solomon@gmail.com',
//     role:'Member'
//   },
// ]

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.third.main,
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: theme.palette.secondary.main,
  }),
  '& .QontoStepIcon-completedIcon': {
    color: theme.palette.secondary.main,
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 17,
    height: 17,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.secondary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.secondary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.third.main : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}))
function QontoStepIcon(props) {
  const { active, completed, className } = props;
  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}
export default function ResearchDetails(props) {
  const [members,setMemebers]=useState([])
  const {state }=useContext(ProfileContext);
  const {host}=state;
  const {user,changed}=useAuth();
  const api=useAxiosPrivate()
  const {rowData,summary,rowMeta}=props
   useEffect(()=>{
      let isMounted=true;
      const controller=new AbortController();
      const getData=async ()=>{
        try{
          const response=await api.get(`research/viewComp/${rowData[0]}`,{
            signal:controller.signal
          })
          // const result=response.data.map((value)=>{
          //   return([
          //     value.id,
          //     value.title,
          //     value.grant_code,
          //     value.status,
          //     `${value.start_date} - ${value.end_date}`,
          //     value.leh,
          //     value.type,
          //     value.institution,
          //   ])
          // })
          // console.log(response.data);
          isMounted &&  setMemebers(response.data)}
        catch(err){
          console.error(err)
        }
      }
      getData();
            return ()=>{
        isMounted=false;
        controller.abort(user.accessToken)
      }
        },[changed])
const [open,setOpen]=useState(false)

  return (
    <>
    <tr>
    <td colSpan="20">
      <Wrapper>
       <Stepper activeStep={rowData[3]==="Pending"?1:rowData[3]==="Active"?2:3} alternativeLabel  connector={<QontoConnector />}>
        {steps.map((label) => (
          <Step key={label} >
            <StepLabel StepIconComponent={QontoStepIcon} ><Header >{label}</Header></StepLabel>
          </Step>
        ))}
      </Stepper>
        <Divider/>
      <Detail>
        <StyledTypography>{`Role: ${rowData[8]}`}</StyledTypography>
        <StyledTypography>{`Type: ${rowData[6]}`}</StyledTypography>
        <StyledTypography>{`Institution: ${rowData[7]}`}</StyledTypography> 
      </Detail>
      <Divider/>
      <Detail>
        <StyledTypography>
         { summary[rowMeta.rowIndex][9]}
        </StyledTypography>
      </Detail>
        <Divider/>
      {rowData[3]!=='Pending' &&
       <Detail>
        <StyledTypography>{`Expire Date: ${rowData[4].split("-")[1]}`}</StyledTypography>
        <Button variant="contained"
        size="small"
        onClick={()=>setOpen(true)}
        sx={{
          bgcolor:'secondary.dark',
          fontWeight: 400,
          color:'#fff',
          "&:hover":{
          bgcolor:'secondary.hover',
          }
          }}
        >Extend Research</Button>
      </Detail>   
      }  
      <Divider/>
       <MemberWrap>
        <StyledTypography>{`Members: `}</StyledTypography>
        {
          members.map((mem)=>(
            <Tooltip title={`${mem.email}`} key={mem.email}>
            <Chip
              avatar={<Avatar src={host+mem.pic+`?token=${user?.accessToken}`} />}
              label={`${mem.name} (${mem.role})`}
            /></Tooltip>
          ))
        }
      </MemberWrap> 
      <Divider/>
      </Wrapper>
        <Dialog open={open}>
          <ExtendResearch close={{ setOpen: setOpen, end_date:rowData[4].split("-")[1], id: rowData[0] }}/>
        </Dialog>
        </td></tr>
    </>
  )
}
